import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import SimpleForm from "@/components/SimpleForm.vue";
import { inject, ref } from "vue";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import { PaymentServiceTypes } from "@/core/types/PaymentTypes";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { CreateByTenantSpec } from "@/core/models/Deposit";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDepositForAccount',
  emits: ["fetchData"],
  setup(__props, { expose: __expose, emit: emits }) {



const ruleFormRef = ref();
const modalRef = ref();
const isLoading = ref(true);
const accountDetails = inject<any>(AccountInjectionKeys.ACCOUNT_DETAILS, {});

const resetForm = async () => {
  formData.value = {
    partyId: accountDetails.value.partyId,
    fundType: accountDetails.value.fundType,
    currencyId: accountDetails.value.currencyId,
    targetTradeAccountUid: accountDetails.value.uid,
  } as CreateByTenantSpec;

  const paymentMethods = await PaymentService.getAccountPaymentMethodById(
    accountDetails.value.id
  );

  accountAvailablePaymentServices.value = Object.keys(paymentMethods)
    .filter((group) => {
      return paymentMethods[group].some((item) => {
        return item.status == 10;
      });
    })
    .reduce((index, group) => {
      index[group] = paymentMethods[group].filter((item) => {
        return item.status == 10;
      });
      return index;
    }, {});

  ruleFormRef.value?.resetFields();
};
const formData = ref<CreateByTenantSpec>({} as CreateByTenantSpec);

const rules = ref({
  paymentServiceId: [
    {
      required: true,
      message: "Please select a payment service",
      trigger: "change",
    },
  ],
  amount: [
    {
      required: true,
      message: "Please input amount",
      trigger: "blur",
    },
  ],
});
const accountAvailablePaymentServices = ref<any>(null);

const submit = async () => {
  formData.value.request = {};
  if (formData.value.paymentServiceId === PaymentServiceTypes.Poli) {
    formData.value.request.MerchantHomepageURL =
      window.location.protocol +
      "//" +
      window.location.host +
      "/wallet/deposit";
    formData.value.request.SuccessURL =
      window.location.protocol +
      "//" +
      window.location.host +
      "/wallet/deposit";
  }
  try {
    isLoading.value = true;
    const res = await AccountService.createDeposit({
      ...formData.value,
      amount: formData.value.amount * 100,
    });
    MsgPrompt.success("Deposit created successfully").then(() => {
      hide();
      emits("fetchData");
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};
const show = async () => {
  await resetForm();
  modalRef.value?.show();
  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.deposit'),
    "is-loading": isLoading.value,
    submit: submit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules.value,
        "label-width": "160px",
        class: "demo-ruleForm",
        "status-icon": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Payment Service",
            prop: "paymentServiceId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.paymentServiceId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.paymentServiceId) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountAvailablePaymentServices.value.deposit, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Amount",
            prop: "amount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.amount,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.amount) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Note",
            prop: "note"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                modelValue: formData.value.note,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.note) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})